export const SORT_PARAM = 'sort';
export const DATE_PARAM = 'date';
export const FROM_DATE_PARAM = 'fromDate';
export const TO_DATE_PARAM = 'toDate';
export const TAG_ID_PARAM = 'tagId';
export const SEARCH_PARAM = 'search';
export const STATUS_PARAM = 'status';
export const LABEL_PARAM = 'labelIds';
export const BOARD_ID_PARAM = 'boardId';
export const CATEGORY_PARAM = 'category';
export const REPORT_ID_PARAM = 'reportId';
export const VENDOR_ID_PARAM = 'vendorId';
